import { tempoApi } from '@/lib/api/tempoApi';
import type { Schedule } from '@/lib/api/types/schedules';

const SCHEDULES_BATCH_LIMIT = 50;

export const getSchedulesByItemIds = async (
  itemIds: Set<number>,
): Promise<Record<number, Schedule>> => {
  if (itemIds.size === 0) return {};

  const itemIdsArray = Array.from(itemIds);

  const chunks = itemIdsArray.reduce((acc: number[][], _, index) => {
    if (index % SCHEDULES_BATCH_LIMIT === 0) {
      acc.push(itemIdsArray.slice(index, index + SCHEDULES_BATCH_LIMIT));
    }
    return acc;
  }, []);

  const allResults: Record<number, Schedule> = {};
  for (const chunk of chunks) {
    const response = await tempoApi().post('api/v1/item-store/schedules/by-item-ids', {
      json: chunk,
    });
    const chunkResult = await response.json<Record<number, Schedule>>();
    Object.assign(allResults, chunkResult);
  }

  return allResults;
};

export const SchedulesApi = {
  getSchedulesByItemIds,
};

export type { Schedule };
